import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const LeaveAwaitingApprovalTable = ({ applications }) => {
  // Define the columns
  const columns = [
    { field: "userEmail", headerName: "Email", flex: 1 },
    { field: "startingDate", headerName: "Starting Date", flex: 1 },
    { field: "endingDate", headerName: "Ending Date", flex: 1 },
  ];

  // Map applications to rows
  const rows = applications?.map((application, index) => ({
    id: index + 1,
    userEmail: application.userEmail,
    startingDate: application.startingdate,
    endingDate: application.endingdate,
  })) || [];

  return (
    <Box p={0}>
      <Typography variant="h5" gutterBottom>
        Pending Leave Applications Awaiting Approval [  {applications.length} ]
      </Typography>
      <Paper elevation={3} sx={{ padding: 0 }}>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            sx={{
              fontSize: "14px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgb(100, 95, 95)",
                color: "white",
              },
              "& .MuiDataGrid-cell": { textAlign: "center" },
              width: "100%", // Ensures the table uses the full available width
              minWidth: 600, // Minimum width for consistency with the other table
            }}
          />
        </div>
      </Paper>
    </Box>
  );
};

export default LeaveAwaitingApprovalTable;
